// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.friends-container {
  background-color: var(--background);
  min-height: 100vh;
  padding-bottom: 64px; /* Match navbar height */
}

.friends-header-container {
  padding-top: 4rem;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: var(--background);
}

.friendsList {
  position: relative;
  min-height: 100%;
  padding-bottom: 80px; /* Add padding to prevent content being hidden */
}

.friendsNotificationCardContainer {
  position: relative;
  text-align: center;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 5px;
  margin-top: 8px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
  transition: box-shadow 0.3s;
  margin: 8px;
  width: 100%;
}

.friendsNotificationCardContainer:hover {
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
}

.friendsNotificationCardContainer button:disabled {
  position: absolute;
  bottom: 10px;
  right: 60px;
  padding: 8px 12px;
  background-color: #6c757d;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  cursor: not-allowed;
}

.friendsNotificationCardContainer button{
  position: absolute;
  bottom: 10px;
  right: 40px;
  padding: 8px 12px;
  background-color: var(--theme-consistent);
  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;
  border: none;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.friendsNotificationCardContainer button:hover {
  background-color: var(--theme-consistent);
  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;
  border: none;
}

.request-loader-container {
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.request-loader-container.show {
  display: flex;
}

.friends-header {
  padding: 8px;
  color: var(--text-primary);
  text-align: center;
}


@media (max-width: 600px) {
  .friendsNotificationCardContainer button{
    position: absolute;
    bottom: 16px;
    right: 24px;
    padding: 4px 6px;
    background-color: var(--theme-consistent);
    box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;
    border: none;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    cursor: pointer;
    width: 100px;
  }

  .friendsNotificationCardContainer button:disabled {
    position: absolute;
    bottom: 13px;
    right: 37px;
    padding: 4px 6px;
    background-color: var(--theme-consistent);
    box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;
    border: none;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    cursor: pointer;
  }

  .friends-container {
    padding-bottom: 72px; /* Slightly larger padding for mobile */
  }

  .friendsList {
    padding-bottom: 88px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/Friends.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB,EAAE,wBAAwB;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB,EAAE,gDAAgD;AACxE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yCAAyC;EACzC,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;;AAGA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yCAAyC;IACzC,wCAAwC;IACxC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yCAAyC;IACzC,wCAAwC;IACxC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,oBAAoB,EAAE,uCAAuC;EAC/D;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".friends-container {\n  background-color: var(--background);\n  min-height: 100vh;\n  padding-bottom: 64px; /* Match navbar height */\n}\n\n.friends-header-container {\n  padding-top: 4rem;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: var(--background);\n}\n\n.friendsList {\n  position: relative;\n  min-height: 100%;\n  padding-bottom: 80px; /* Add padding to prevent content being hidden */\n}\n\n.friendsNotificationCardContainer {\n  position: relative;\n  text-align: center;\n  box-shadow: rgb(0 0 0 / 15%) 0px 1px 5px;\n  margin-top: 8px;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #fff;\n  transition: box-shadow 0.3s;\n  margin: 8px;\n  width: 100%;\n}\n\n.friendsNotificationCardContainer:hover {\n  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);\n}\n\n.friendsNotificationCardContainer button:disabled {\n  position: absolute;\n  bottom: 10px;\n  right: 60px;\n  padding: 8px 12px;\n  background-color: #6c757d;\n  color: #fff;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: not-allowed;\n}\n\n.friendsNotificationCardContainer button{\n  position: absolute;\n  bottom: 10px;\n  right: 40px;\n  padding: 8px 12px;\n  background-color: var(--theme-consistent);\n  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;\n  border: none;\n  color: #fff;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.friendsNotificationCardContainer button:hover {\n  background-color: var(--theme-consistent);\n  box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;\n  border: none;\n}\n\n.request-loader-container {\n  display: none;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.request-loader-container.show {\n  display: flex;\n}\n\n.friends-header {\n  padding: 8px;\n  color: var(--text-primary);\n  text-align: center;\n}\n\n\n@media (max-width: 600px) {\n  .friendsNotificationCardContainer button{\n    position: absolute;\n    bottom: 16px;\n    right: 24px;\n    padding: 4px 6px;\n    background-color: var(--theme-consistent);\n    box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;\n    border: none;\n    color: #fff;\n    border-radius: 4px;\n    font-size: 10px;\n    cursor: pointer;\n    width: 100px;\n  }\n\n  .friendsNotificationCardContainer button:disabled {\n    position: absolute;\n    bottom: 13px;\n    right: 37px;\n    padding: 4px 6px;\n    background-color: var(--theme-consistent);\n    box-shadow: rgb(0 0 0 / 15%) 0px 2px 8px;\n    border: none;\n    color: #fff;\n    border-radius: 4px;\n    font-size: 10px;\n    cursor: pointer;\n  }\n\n  .friends-container {\n    padding-bottom: 72px; /* Slightly larger padding for mobile */\n  }\n\n  .friendsList {\n    padding-bottom: 88px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
